module.exports = __webpack_public_path__ + "img/Spine_Single_Frame0001.a335018f.jpg";